import { render, staticRenderFns } from "./Cambio_De_Horario_Detalle.vue?vue&type=template&id=6962c5f3"
import script from "./Cambio_De_Horario_Detalle.vue?vue&type=script&lang=js"
export * from "./Cambio_De_Horario_Detalle.vue?vue&type=script&lang=js"
import style0 from "./Cambio_De_Horario_Detalle.vue?vue&type=style&index=0&id=6962c5f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports